<p-menubar class="menu-bar">
  <ng-template pTemplate="start">
    <div class="start-container">
      <div class="logo-container">
        <img
          src="assets/WatchGuard_Logo.svg"
          alt="logo"
          height="40"
          class="logo"
        />
      </div>
      <div class="test-name">
        <h2>{{testName}}</h2>
      </div>
    </div>
    
  </ng-template>

  <ng-template pTemplate="end" *ngIf="showCompleteNavbar">
    <div class="inline-container">
      <button
          pButton
          [text]="true"
          [plain]="true"
          class="instruction-button"
          [label]="testNavbarUIStrings.instruction"
          (click)="showInstructionPopup()"
        ></button>
      <div class="inline-container-time">
        <b><i class="pi pi-clock"></i></b>
        <p><b>{{testNavbarUIStrings.time_remaining}} {{ formatTime(timeRemaining) }}</b></p>
      </div>
      <p>
        <button
          class="p-button-success"
          pButton
          pRipple
          [label]="testNavbarUIStrings.submit"
          (click)="showFinalQuizPopup()"
        ></button>
      </p>
    </div>
  </ng-template>
</p-menubar>
<p-dialog 
  [(visible)]="submitTestPopup"
  [modal]="true" 
  [dismissableMask]="false" 
  [closable]="true"
  (onHide)="submitTestPopup.set(false)"
>
  <app-confirm-submit
  ></app-confirm-submit>
</p-dialog>
<p-dialog
  [(visible)]="instructionPopup"
  [modal]="true"
  [dismissableMask]="false"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [blockScroll]="true"
  appendTo="body"
>
  <app-instruction [proctorSetting]="proctoringSetting" [checkBox]="!instructionPopup">
  </app-instruction>
</p-dialog>
